export default __webpack_public_path__ + "static/media/i2.96be1d57.png";